import { ExpertAnketaQuestionAutoRate } from './ExpertAnketaQuestionAutoRate';

export default ExpertAnketaQuestionAutoRate;